import classNames from "classnames";
import styles from './Button.module.scss'
import Loader from "@/components/UI/Loader/Loader";

type Props = {
  loading?: boolean
  simple?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: 'red' | 'blue' | 'grey' | 'purple'
}

const Button = (props: Props) => {
  const passedProps = {...props, loading: undefined}
  return (
    <button {...passedProps} type={props.type || 'button'} className={classNames(styles.button, props.className, props.color && styles[props.color], props.simple && styles.simple)} >
      {props.loading ? <Loader/> : props.children}
    </button>
  )
}

export default Button;